<div main-item>
  <label class="text-nowrap mr-2" *ngIf="label" [id]="labelId" [attr.for]="fieldId(0)">{{ label }}
    <span *ngIf="require" class="text-danger" aria-hidden="true">*</span>
  </label>

  <div *ngFor="let item of inputValue; let i = index">
    <div class="d-flex mt-1">
      <input #field="ngModel" type="text" class="form-control flex-grow-1" [readOnly]="readonly"
        [id]="fieldId(i)" [required]="require" [pattern]="pattern" [ngModel]="item"
        [attr.aria-labelledby]="label ? labelId : null"
        [attr.aria-required]="require ? 'true' : null"
        [attr.aria-invalid]="errorShown(i) ? 'true' : null"
        [attr.aria-describedby]="errorShown(i) ? errorId(i) : null"
        (blur)="errorState.schedule()"
        (change)="onChange(i, $event)" />

      <button class="col border-0 mx-1" (click)="removeItem(i)" *ngIf="!readonly && inputValue.length > 1"
        [attr.aria-label]="'unifiedForms.removeItem' | translate">
        <i class="fa fa-trash text-danger" aria-hidden="true"></i>
      </button>
      <button class="col border-0 mx-1" (click)="addItem()" *ngIf="!readonly && (inputValue.length-1) === i"
        [attr.aria-label]="'unifiedForms.addItem' | translate">
        <i class="fa fa-add text-success" aria-hidden="true"></i>
      </button>
    </div>

    <div *ngIf="errorShown(i)" [id]="errorId(i)" role="alert" class="alert alert-danger my-1 py-1">
      <div *ngIf="field.errors?.required">{{ 'validation.required' | translate }}</div>
      <div *ngIf="field.errors?.pattern">{{ patternError? patternError : 'validation.pattern' | translate }}
      </div>
    </div>
  </div>
</div>
